import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { useAdminStore } from '../../store/adminStore';
import './AdminInterface.css';

export default function AdminInterface() {
    const isAuthenticated = useAdminStore(state => state.isAuthenticated);

    return (
        <div className="admin-interface">
            {!isAuthenticated ? (
                <AdminLogin />
            ) : (
                <AdminDashboard />
            )}
        </div>
    );
}
